import { store } from '@/store';
import api from '@api/Api';

export default {

    getUser() {
        return api().get(`/users/me`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    updateUser(params) {
        return api().put(`/users/me`, params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    deleteUser() {
        return api().delete(`/users/me`);
    },

    updatePassword(params) {
        return api().put(`/users/me/password`, params);
    },

    updateProject(projectId) {
        return api().put(`/users/me/projects/${projectId}`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    getCompanies() {
        return api().get(`/users/me/companies/`);
    },

    createCompany(params) {
        return api().post(`/users/me/companies`, params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    updateCompany(companyId) {
        return api().put(`/users/me/companies/${companyId}`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    leaveCompany(companyId) {
        return api().delete(`/users/me/companies/${companyId}`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    verifyEmail() {
        return api().post(`/users/me/verify-email`);
    },

    sendFeedback(params) {
        return api().post(`/users/me/feedback`, params);
    },

    getAffiliate() {
        return api().get(`/users/me/affiliate`);
    },

    createAffiliate(params) {
        return api().post(`/users/me/affiliate`, params);
    },

    updateAffiliate(params) {
        return api().put(`/users/me/affiliate`, params);
    },

}
